import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

import { FeatureFlag } from '~/lib/flags/flags';

interface FeatureFlagParams {
  default?: boolean;
}

export type FeatureFlags = { [flag in FeatureFlag]: boolean };

export const useFeatureFlags = (): FeatureFlags => {
  const flagSet = useFlags();

  return useMemo(() => {
    return Object.entries(flagSet)
      .filter(([_, value]) => typeof value === 'boolean')
      .reduce((acc, [key, value]) => {
        const flag = key as FeatureFlag;
        acc[flag] = value as boolean;
        return acc;
      }, {} as FeatureFlags);
  }, [flagSet]);
};

export const useFeatureFlag = (flag: FeatureFlag, params?: FeatureFlagParams): boolean => {
  const flagSet = useFlags();

  return useMemo(() => {
    const flagValue = flagSet[flag];
    if (flagValue === undefined) {
      return params?.default ?? false;
    }

    return flagValue;
  }, [flagSet]);
};
